<template>
    <v-card tile flat
            class="teamName theme-text transparent"
            :class="team.component.position ==='appBar' ? 'appbar-result-action': ''"
            :style="{color: team.isActive ? ($vuetify.theme.dark ? '#ffffff !important' : '#000000 !important') : ''}">
        {{ team.component.position === 'appBar' ? teamShortName : teamName }}
    </v-card>
</template>

<script>
    export default {
        name: "TeamName",
        props: {
            team: Object,
            teamShortName: String,
            teamName: String
        }
    }
</script>

<style scoped>
    .teamName {
        font-size: 16px;
        font-weight: bold;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        margin-left: 10px;
        margin-right: 10px;
    }

    .appbar-result-action.teamName {
        font-size: 14px;
        font-stretch: condensed;
        font-family: 'Roboto Condensed';
        text-align: right;
    }
</style>
